import { AlertType as s } from "@jetbrains/ring-ui-built/components/alert/alert.js";
import o from "@jetbrains/ring-ui-built/components/alert-service/alert-service.js";
const c = 4e3, n = (r, e, t, A = c) => o.addAlert(r, e, A, t), u = (r, e, t) => o.addAlert(r, s.ERROR, e, t), E = (r, e, t) => n(r, s.MESSAGE, t, e), a = (r, e, t) => n(r, s.WARNING, t, e), d = (r, e, t) => n(r, s.SUCCESS, t, e), h = (r, e, t) => n(r, s.LOADING, t, e), i = (r) => {
  o.remove(r);
}, w = () => {
  o.showingAlerts = [], o.renderAlerts();
};
export {
  i as removeAlert,
  w as removeAllAlerts,
  u as showError,
  h as showLoading,
  E as showMessage,
  d as showSuccess,
  a as showWarning
};
